'use client';
import 'react/jsx-runtime';
import { IconApplicationEdit } from '../../svg/icons/icon-application-edit.js';
import { IconBuildYourCareer } from '../../svg/icons/icon-build-your-career.js';
import { IconCertificate } from '../../svg/icons/icon-certificate.js';
import { IconChatBubbles } from '../../svg/icons/icon-chat-bubbles.js';
import { IconFolderPlus } from '../../svg/icons/icon-folder-plus.js';
import { IconPackage } from '../../svg/icons/icon-package.js';
import { IconQuestion } from '../../svg/icons/icon-question.js';
import { IconVideo } from '../../svg/icons/icon-video.js';

const iconMap = {
    IconApplicationEdit,
    IconBuildYourCareer,
    IconCertificate,
    IconChatBubbles,
    IconFolderPlus,
    IconPackage,
    IconQuestion,
    IconVideo,
};
const isIconName = (value) => {
    return Object.keys(iconMap).includes(value);
};

export { iconMap, isIconName };
//# sourceMappingURL=constants.js.map
